import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = { class: "notifications" }
const _hoisted_2 = {
  key: 0,
  class: "pallino"
}
const _hoisted_3 = { key: 0 }
const _hoisted_4 = { class: "notificationRow" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_icon_bell = _resolveComponent("icon-bell")!
  const _component_localized_text = _resolveComponent("localized-text")!
  const _component_backendNotificationNewChatMessage = _resolveComponent("backendNotificationNewChatMessage")!
  const _component_backendNotificationVillageTripBooked = _resolveComponent("backendNotificationVillageTripBooked")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("button", {
      class: "opener",
      onClick: _cache[0] || (_cache[0] = ($event: any) => {_ctx.isOpen = !_ctx.isOpen; _ctx.$store.state.hasNotifications = false;})
    }, [
      _createVNode(_component_icon_bell),
      (_ctx.$store.state.hasNotifications)
        ? (_openBlock(), _createElementBlock("div", _hoisted_2))
        : _createCommentVNode("", true)
    ]),
    (_ctx.isOpen)
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: "drawerBg",
          onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.isOpen = false))
        }, [
          _createElementVNode("div", {
            class: "drawer",
            onScroll: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.checkEnd && _ctx.checkEnd(...args))),
            onClick: _cache[2] || (_cache[2] = _withModifiers(() => {}, ["stop"]))
          }, [
            (_ctx.list.length == 0)
              ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                  _createElementVNode("div", _hoisted_4, [
                    _createVNode(_component_localized_text, {
                      localizedKey: "Nessuna notifica ricevuta",
                      text: "Nessuna notifica ricevuta"
                    })
                  ])
                ]))
              : _createCommentVNode("", true),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.list, (item) => {
              return (_openBlock(), _createElementBlock("div", {
                key: item.identifier
              }, [
                (item.type == 'BackendNotificationNewChatMessage')
                  ? (_openBlock(), _createBlock(_component_backendNotificationNewChatMessage, {
                      key: 0,
                      onClose: ($event: any) => (_ctx.onClose(item)),
                      item: item
                    }, null, 8, ["onClose", "item"]))
                  : _createCommentVNode("", true),
                (item.type == 'BackendNotificationVillageTripBooked')
                  ? (_openBlock(), _createBlock(_component_backendNotificationVillageTripBooked, {
                      key: 1,
                      onClose: ($event: any) => (_ctx.onClose(item)),
                      item: item
                    }, null, 8, ["onClose", "item"]))
                  : _createCommentVNode("", true)
              ]))
            }), 128))
          ], 32)
        ]))
      : _createCommentVNode("", true)
  ]))
}